import { App, inject } from "vue";
import { AnalyticsTracker } from "@/tracking/analytics/analyticsTracker.ts";

export const analyticsPlugin = {
  install(app: App) {
    app.provide('analytics', new AnalyticsTracker())
  }
};

export function getAnalyticsTracker(): AnalyticsTracker {
  const analytics: AnalyticsTracker | undefined = inject('analytics')
  if (analytics) {
    return analytics
  }
  console.warn(`No AnalyticsEventTracker detected. Initializing new tracker`)
  return new AnalyticsTracker()
}